import * as React from 'react';
import { Link } from 'react-router-dom';
import Button, { ButtonProps } from '@material-ui/core/Button';
import { LocationDescriptor } from 'history';

interface Props extends ButtonProps {
  to: LocationDescriptor;
}

const SubLink = (p: Props) => {
  const { innerRef, ...other } = p;
  return <Link {...other} />;
};

export default (props: Props) => <Button {...props} component={SubLink} />;



// WEBPACK FOOTER //
// ./src/components/LinkButton.tsx